const outcomesUtils = (function () {
    function showInUseWarning(msg) {
        var warningPopup = POPUP.build({});
        warningPopup.classList.add('warning');
        var message = document.createElement('p');
        message.innerHTML = msg;
        message.style.marginBottom = '15px';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var okBtn = button.build({
            text: 'Ok',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(warningPopup);
            }
        });

        btnWrap.appendChild(okBtn);
        warningPopup.appendChild(message);
        warningPopup.appendChild(btnWrap);
        POPUP.show(warningPopup);
        warningPopup.querySelector('.closePopupBtn').remove();
    }
    function showServiceDeleteWarning(serviceId, callback) {
        var deleteWarningPopup = POPUP.build({});
        var message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to delete this service?';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        btnWrap.style.marginTop = '25px';
        var yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: async () => {
                POPUP.hide(deleteWarningPopup);
                const result = await outcomesAjax.deleteService(serviceId);
                if (!result || result.deleteServiceResult == null) {
                    failSave.show('An error occurred.');
                    setTimeout(() => { failSave.hide(); }, 2000);
                    return;
                }
                const deleteResult = JSON.parse(result.deleteServiceResult);
                if (deleteResult && deleteResult[0]?.msg === 'success') {
                    successfulSave.show('Deleted');
                    setTimeout(async () => {
                        if (callback) {
                           callback();
                        }
                        successfulSave.hide();
                    }, 2000);
                }
                else {
                    failSave.show('An error occured.');
                    setTimeout(() => { failSave.hide(); }, 2000);
                    return;
                }
            }
        });
        var noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deleteWarningPopup);
            }
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deleteWarningPopup.appendChild(message);
        deleteWarningPopup.appendChild(btnWrap);
        POPUP.show(deleteWarningPopup);
    }
    function showOutcomeDeleteWarning(outcomeId, callback) {
        var deleteWarningPopup = POPUP.build({});
        var message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to delete this outcome?';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        btnWrap.style.marginTop = '25px';
        var yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: async () => {
                POPUP.hide(deleteWarningPopup);
                const result = await outcomesAjax.deleteOutcome(outcomeId);
                if (!result || result.deleteOutcomeResult == null) {
                    failSave.show('An error occurred.');
                    setTimeout(() => { failSave.hide(); }, 2000);
                    return;
                }
                const deleteResult = JSON.parse(result.deleteOutcomeResult);
                if (deleteResult && deleteResult[0]?.msg === 'success') {
                    successfulSave.show('Deleted');
                    setTimeout(async () => {
                        if (callback) {
                            callback();
                        }
                        successfulSave.hide();
                    }, 2000);
                }
                else {
                    failSave.show('An error occured.');
                    setTimeout(() => { failSave.hide(); }, 2000);
                    return;
                }
            }
        });
        var noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deleteWarningPopup);
            }
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deleteWarningPopup.appendChild(message);
        deleteWarningPopup.appendChild(btnWrap);
        POPUP.show(deleteWarningPopup);
    }
    return {
        showInUseWarning,
        showServiceDeleteWarning,
        showOutcomeDeleteWarning,
    }
})();
